<!-- 版房控制台的修改页面 -->
<template>
    <div>
        <el-dialog
                :title="title"
                @closed="closed"
                :visible.sync="show"
                width="50%">

            <el-form ref="stereoForm" :rules="rules" label-position="left" style="text-align:left"
                     label-width="100px"
                     :model="formData">
                <el-form-item label="工艺流程:" :rules="rules.craftProcessRule" prop="craftProcess" size="mini">
                    <slot name="label">
                        <i v-show="selectLoading" class="el-icon-loading"></i>
                        <el-tooltip effect="dark" content="您有更改未保存" placement="top-start">
                            <el-tag v-show="changed.craftProcess" size="mini" effect="plain" style="margin-right: 5px">
                                **
                            </el-tag>
                        </el-tooltip>
                    </slot>
                    <el-select
                            @change="refreshFormChanged"
                            popper-class="-popper-class"
                            v-model="formData.craftProcess">
                        <template>
                            <el-option
                                    v-for="(craftProcess,index) in craftProcessArray"
                                    :disabled="!craftProcess.selected"
                                    :key="index"
                                    :label="craftProcess.name"
                                    :value="craftProcess.id">
                                <div>
                                    <el-row>
                                        <span style="float: left">{{ craftProcess.name }}</span>

                                        <el-tag v-if="!craftProcess.selected"
                                                style="float: right;margin: 5px"
                                                type="danger"
                                                size="mini">已停用
                                        </el-tag>
                                        <el-tag
                                                style="float: right;margin: 5px"
                                                type="info"
                                                size="mini">关联商品:{{craftProcess.used_nums}}
                                        </el-tag>
                                    </el-row>
                                    <el-row>
                                        <template v-for="craftStep in craftProcess.craftprocessstep_set">
                                            <el-tag
                                                    effect="plain"
                                                    size="mini"
                                                    style="float: left;margin: 0 2px 5px">
                                                {{ craftStep.index }}.{{ craftStep.craft_expr.name }}
                                            </el-tag>
                                        </template>
                                    </el-row>
                                </div>
                            </el-option>
                        </template>
                    </el-select>
                </el-form-item>
            </el-form>
            <el-row class="funcRow">
                <el-button icon="el-icon-tickets" @click="saveClick" :loading="saveLoading" type="primary" size="mini">保
                    存
                </el-button>

                <el-button icon="el-icon-finished" @click="finishClick" :loading="finishLoading" type="primary"
                           size="mini">完 成
                </el-button>

                <el-button :disabled="!isReserve" icon="el-icon-user" @click="reserveClick" :loading="reserveLoading"
                           type="warning"
                           size="mini">撤销/反审
                </el-button>

                <el-button  @click="toCreateCraftProcess"  type="primary"
                           size="mini">新增工艺流程
                </el-button>



            </el-row>
            <div slot="footer">
                <el-button size="mini" @click="close">取 消</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import {mapState, mapGetters, mapMutations} from 'vuex'

    export default {
        name: "OrderStereoModify",
        data() {
            return {
                // 是否显示当前对话框
                show: false,

                // 表单数据
                formData: {
                    craftProcess: '',
                },

                // 记录原始数据，用来比较显示用户是否更改了数据
                metaData: {
                    craftProcess: '',
                },

                // 记录表单中的数据是否发生了改变
                changed: {
                    craftProcess: false,
                },

                // 表单数据 craftProcess 是否发生了改动
                craftProcessChanged: false,

                // 表单验证规则
                rules: {
                    craftProcessRule: this.$utils.requiredRules
                },

                // 选项 select 初始化时的加载
                selectLoading: false,

                // 点击保存时的 加载 loading
                saveLoading: false,

                // 点击完成时的 加载 loading
                finishLoading: false,

                // 撤销/反审 的加载 loading
                reserveLoading: false,
            }
        },
        computed: {
            /**
             * 当前的 form 表单组件
             */
            formComponent() {
                return this.$refs.stereoForm
            },

            /**
             * 工艺流程是否可以反审/撤销
             */
            isReserve() {
                if (this.currentOrder) {
                    return this.currentOrder.craftrecord_set.length > 0
                }
                return false

            },

            /**
             * 所有的工艺模版信息
             */
            craftProcessArray() {
                return this.CraftProcessData['CraftProcessArray']
            },

            /**
             * 对话框的标题
             * @returns {string}
             */
            title() {
                if (this.currentOrder) {
                    return `订单:${this.currentOrder.the_id}  版房编辑 (${this.currentOrder.order_base.base_id})`
                }
                return ''
            },

            /**
             * 当前正在处理的订单 (currentStereoOrder 的链接)
             */
            currentOrder() {
                return this.currentStereoOrder
            },

            /**
             * 将 Vuex 中的属性映射到组件中
             */
            ...mapState(['currentStereoOrder']),
            ...mapGetters(['CraftProcessData']),
        },
        methods: {
            /**
             * 跳转到新增工艺流程页面
             */
            toCreateCraftProcess(){
                this.$Jquery("li.stereo-class").removeClass('is-active')
                this.close()
                this.$router.replace({name: 'orderSetup', params: { activeName: 'craftProcessSetup' }})
            },

            /**
             * 点击撤销/反审按钮
             */
            reserveClick() {
                this.reserveLoading = true
                const url = `${this.$const.orderListUrl}${this.currentOrder.id}/reserve_stereo/`
                this.$postRequest(url)
                    .then(response => {
                        this.$message({
                            type: 'success',
                            showClose: true,
                            message: '撤销成功，现在可以重新选择工艺流程！'
                        })
                        this.updateOrder(response.data)
                        this.setCurrentStereoOrder(response.data)
                        this.reserveLoading = false
                    })
                    .catch(() => {
                        this.reserveLoading = false
                    })
            },

            /**
             * 刷新表单数据中 更改的字段信息
             */
            refreshFormChanged() {
                for (const key in this.metaData) {
                    this.changed[key] = (this.metaData[key] !== this.formData[key])
                }
            },

            /**
             * 将 meta 中的数据 与 表单中的数据同步
             */
            syncMetaForm() {
                for (let key in this.metaData) {
                    this.metaData[key] = this.formData[key]
                }
            },

            /**
             * 初始化 form 表单数据
             */
            initFormData() {
                if (this.currentOrder) {
                    this.initCraftProcess()
                }
                this.syncMetaForm()
                this.refreshFormChanged()
            },

            /**
             * 初始化表单的 CraftProcess 数据
             */
            initCraftProcess() {

                this.selectLoading = true
                const craftProcessUrl = `${this.$const.goodbaseCraftProcessUrl}`;
                const params = {
                    'base_id': this.currentOrder.order_base.base_id
                };
                this.$getRequest(craftProcessUrl, params)
                    .then(response => {
                        this.selectLoading = false
                        if (response.data.length > 0) {
                            this.formData.craftProcess = response.data[0].craft_process
                        } else {
                            this.formData.craftProcess = ''
                        }
                    })
                    .catch(error => {
                        this.selectLoading = false
                    })
            },

            /**
             * 点击保存当前表单信息事件
             */
            saveClick() {
                // 点击保存时，先对表单进行验证
                // validated,message 分别是验证结果 已经验证信息(当 validated 为 false 时)
                this.formComponent.validate((validated, message) => {
                    if (validated) {
                        this._sendUpdateRequest()
                    }
                })
            },

            /**
             * 检查是否有属性改动，然后是否进行下一步，如果没有改动 则返回 true，否则返回false
             */
            changeCheck() {
                for (let key in this.changed) {
                    if (this.changed[key]) { // 发生了改变
                        this.$message({
                            type: 'error',
                            showClose: true,
                            message: '检测到未保存的信息，请保存后再点击`完成`',
                        })
                        return false
                    }
                }
                return true
            },

            /**
             * 点击`完成`事件
             */
            finishClick() {
                // 点击完成时，先对表单进行验证
                // validated,message 分别是验证结果 已经验证信息(当 validated 为 false 时)
                this.formComponent.validate((validated, message) => {
                    if (validated && this.changeCheck()) {
                        this._sendFinishRequest()
                    }
                })
            },

            /**
             * 发送更新/保存 请求
             */
            _sendUpdateRequest() {
                this.saveLoading = true
                const url = `${this.$const.goodbaseCraftProcessUrl}`
                const data = {
                    base_id: this.currentOrder.order_base.base_id,
                    craft_process: this.formData.craftProcess,
                }
                // 发送 request 请求
                this.$postRequest(url, data)
                    .then(response => {
                        this.$message({
                            type: 'success',
                            showClose: true,
                            message: '保存成功',
                        })
                        this.saveLoading = false
                        this.syncMetaForm()
                        this.refreshFormChanged()
                    })
                    .catch(error => {
                        this.saveLoading = false
                    })

            },

            /**
             * 发送 `完成` 请求
             */
            _sendFinishRequest() {
                this.finishLoading = true
                const url = `${this.$const.orderListUrl}${this.currentOrder.id}/stereo/`
                const data = {
                    stereoinfo: {
                        result: 'PASS',
                        remark: '', // 备注信息
                    }
                }
                this.$patchRequest(url, data)
                    .then(response => {
                        this.finishLoading = false
                        const orders = [response.data]
                        this.removeStereoOrders({orders, update: true})
                        this.$message({
                            type: 'success',
                            showClose: true,
                            message: '成功完成！',
                        })
                        this.close()
                    })
                    .catch(error => {
                        this.finishLoading = false
                    })
            },

            /**
             * 关闭对话框
             */
            close() {
                this.show = false
            },

            /**
             * 打开对话框
             */
            open() {
                this.show = true
            },

            /**
             * 关闭对话框完成后的处理
             */
            closed() {
                this.formComponent.clearValidate()
            },

            ...mapMutations(['removeStereoOrders', 'setCurrentStereoOrder', 'updateOrder'])
        },
        watch: {
            currentOrder() {
                this.initFormData()
            }
        },
    }
</script>
<style scoped>
    .funcRow .el-button {
        float: left;
        margin-right: 8px;
    }
</style>

<style>
    .-popper-class .el-scrollbar {
        width: 700px;
    }

    .-popper-class .el-select-dropdown__item.selected {
        color: #67C23A;
    }

    .-popper-class .el-select-dropdown__item {
        height: auto;
    }
</style>